// Assets
import CORPORATE from "@/assets/icons/franchises/corporate.svg";
import CORPORATEWHITE from "@/assets/icons/franchises/corporate_white.svg";
import BC from "@/assets/icons/franchises/chevrolet_icon.svg";
import BCWHITE from "@/assets/icons/franchises/chevrolet_icon_white.svg";
import BCADILLAC from "@/assets/icons/franchises/cadillac_icon.svg";
import BCADILLACWHITE from "@/assets/icons/franchises/cadillac_icon_white.svg";
import BVCD from "@/assets/icons/franchises/volvo_icon.svg";
import BVCDWHITE from "@/assets/icons/franchises/volvo_icon_white.svg";
import BCDJRD from "@/assets/icons/franchises/chrysler_icon.svg";
import BCDJRDWHITE from "@/assets/icons/franchises/chrysler_icon_white.svg";
import BAFD from "@/assets/icons/franchises/alfa_romeo_icon.svg";
import BAFDWHITE from "@/assets/icons/franchises/alfa_romeo_icon_white.svg";

const getImagePath = (logo: string, isSelected: boolean) => {
	const logoMap: { [key: string]: string } = {
		"corporate.svg": isSelected ? CORPORATEWHITE : CORPORATE,
		"chevrolet.svg": isSelected ? BCWHITE : BC,
		"cadillac.svg": isSelected ? BCADILLACWHITE : BCADILLAC,
		"volvo.svg": isSelected ? BVCDWHITE : BVCD,
		"chrysler.svg": isSelected ? BCDJRDWHITE : BCDJRD,
		"alfa_romeo.svg": isSelected ? BAFDWHITE : BAFD,
	};

	return logoMap[logo] || (isSelected ? BCWHITE : BC);
};

export interface FranchiseLogoProps {
	logo: string;
	isSelected: boolean;
	className?: string;
}

export default function FranchiseLogo(props: Readonly<FranchiseLogoProps>) {
	return (
		<img
			src={getImagePath(props.logo, props.isSelected) || ""}
			alt={props.logo}
			className={props.className ?? "h-[26px] max-w-[49px]"}
		/>
	);
}
